/* @flow */

import * as React from 'react';

import classnames from 'classnames';

import {StackLegacy} from 'shells/layout';

import {IMAGE_CAROUSEL_SLIDES} from './consts';

import './image-carousel.module.css';

export function ImageCarousel() {
    const [currentSlide, setCurrentSlide] = React.useState(0);
    const [isTransitioning, setIsTransitioning] = React.useState(false);

    const handleSlideChange = React.useCallback(
        (newIndex: number) => {
            if (newIndex === currentSlide || isTransitioning) return;

            setIsTransitioning(true);
            setTimeout(() => {
                setCurrentSlide(newIndex);
                setTimeout(() => setIsTransitioning(false), 50);
            }, 150);
        },
        [currentSlide, isTransitioning]
    );

    React.useEffect(() => {
        const interval = setInterval(() => {
            handleSlideChange((currentSlide + 1) % IMAGE_CAROUSEL_SLIDES.length);
        }, 5000);

        return () => clearInterval(interval);
    }, [currentSlide, handleSlideChange]);

    const imageStyle = classnames('carousel-image', {
        'is-fading': isTransitioning,
    });

    const subheadingStyle = classnames('subheading', {
        'is-fading': isTransitioning,
    });

    return (
        <div className='flex flex-dir-col full-width full-height align-center'>
            <img src={IMAGE_CAROUSEL_SLIDES[currentSlide].image} styleName={imageStyle} />
            <div styleName='subheading-container'>
                <div styleName={subheadingStyle}>
                    {IMAGE_CAROUSEL_SLIDES[currentSlide].subtitle}
                </div>
                <StackLegacy spacing={8} isHorizontal={true}>
                    {IMAGE_CAROUSEL_SLIDES.map((slide, index) => {
                        const breadcrumbStyle = classnames('breadcrumb', {
                            'breadcrumb-active': index === currentSlide,
                        });

                        return (
                            <div
                                key={slide.key}
                                onClick={() => handleSlideChange(index)}
                                styleName={breadcrumbStyle}
                            />
                        );
                    })}
                </StackLegacy>
            </div>
        </div>
    );
}
